import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SavedPagesProps {
  savedPagesList: Array<any>;
  activePageTitle: string;
  activePageItem: object;
  viewUpdate: boolean;
  calenderInfo: object;
}

const initialState: SavedPagesProps = {
  savedPagesList: [],
  activePageTitle: "",
  activePageItem: {},
  viewUpdate: false,
  calenderInfo: {},
};

export const savedPages = createSlice({
  name: "savedPages",
  initialState,
  reducers: {
    setSavedPagesList: (state, action: PayloadAction<Array<any>>) => {
      state.savedPagesList = action.payload;
    },
    setActivePageTitle: (state, action: PayloadAction<string>) => {
      state.activePageTitle = action.payload;
    },
    setActivePageItem: (state, action: PayloadAction<object>) => {
      state.activePageItem = action.payload;
    },
    setViewUpdate: (state, action: PayloadAction<boolean>) => {
      state.viewUpdate = action.payload;
    },
    setCalenderInfo: (state, action: PayloadAction<object>) => {
      state.calenderInfo = action.payload;
    },
  },
});

export const {
  setSavedPagesList,
  setActivePageTitle,
  setActivePageItem,
  setViewUpdate,
  setCalenderInfo,
} = savedPages.actions;

export default savedPages.reducer;
